<!-- コード入力コンポーネント -->
<template>
  <div class="passcode__wrapper">
    <!-- 救済コードを入力してください -->
    <p class="passcode__wrapper--title">
      {{ $t("MyTicketTicketing.inputPasscode") }}
    </p>

    <!-- 打たれた番号の表示エリア -->
    <CodeInputDisplay
      :code="emergency_code"
      @parentMethod="sliceNumberFromCode"
    />

    <!-- 1~9,0のボタン群 -->
    <CodeInputButtons
      :code="emergency_code"
      :isFulfill="isFulfill"
      @parentMethod1="joinNumberToCode"
      @parentMethod2="pushedOK"
    />
  </div>
</template>

<script>
// Methods
import bookService from "@/services/book";
import sheetService from "@/services/sheet";
import frameService from "@/services/frame";

// API
import API from "@/API";

// Vue
import {
  onMounted,
  computed,
  watch,
  watchEffect,
  ref,
  SetupContext,
} from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "TheSheetEmergencyCode0-9ButtonForm",
  props: {
    multiSheetValidIdsArray: {
      type: Array,
    },
  },
  setup(props, context) {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const emergency_code = ref("");

    const isFulfill = ref(false);

    const bookGroup = computed(() => store.getters["ticketing/bookGroup"]);
    const masterBook = computed(() => store.getters["ticketing/masterBook"]);
    const book = computed(() => store.getters["ticketing/book"]);
    const sheet = computed(() => store.getters["ticketing/sheet"]);
    const masterSheet = computed(() => store.getters["ticketing/masterSheet"]);
    const frame = computed(() => store.getters["ticketing/frame"]);

    // 押された数字を文字列(code)に末尾に追加
    const joinNumberToCode = (number) => {
      emergency_code.value += number;
    };

    // 文字列(code)から末尾を削除
    const sliceNumberFromCode = (number) => {
      emergency_code.value = emergency_code.value.slice(0, -1);
    };

    const resetCode = () => {
      emergency_code.value = "";
    };

    // 子コンポーネントでOKが押されて発火
    const pushedOK = async () => {
      context.emit("open-dialog", "DialogLoading");
      console.log("emergency_code :>> ", emergency_code.value);

      if (emergency_code.value.length >= 7) {
        // 7桁以上はワンタイムパス(Emotパスポート)であると判断できるので、救済コードが有効か判別するためにメニュー取得のAPI実行
        try {
          // 取得したmenuはstoreに保持しておく
          await API.getSheetMenus(
            masterSheet.value.id,
            null,
            emergency_code.value
          );
          // 救済コードを引数にシートページへリダイレクト
          redirectToSheetWithOnetimeCode(emergency_code.value);
        } catch (err) {
          resetCode();
          console.log("err :>> ", err);
          // 親コンポーネントでエラー内容に合わせて処理するので、イベント発火
          context.emit("error-handring", err.response.data.error);
        }
      } else {
        // 6桁までは救済コードとして処理

        // フレームの有効化(必要であればブックの有効化)
        if (await executeValidAPI()) {
          // 最新の情報へアップデート
          await sheetService.getSheetInfomations(route);

          // 成功ダイアログ表示
          context.emit(
            "open-dialog",
            "DialogValidFramesWithEmergencyCodeComplete"
          );
        }
      }
    };

    const issueExternalCoupon = async () => {
      //issue external coupon when using sheet ticket
      try {
        const numberCouponIssued = await API.issueExternalCoupon(
          masterBook.value.id,
          book.value.id
        );

        if (numberCouponIssued > 0) {
          store.commit("ticketing/setIssuedExternalCouponStatusOfSheet", true);
        } else {
          store.commit("ticketing/setIssuedExternalCouponStatusOfSheet", null);
        }
      } catch (err) {
        store.commit("ticketing/setIssuedExternalCouponStatusOfSheet", false);
        console.log("TheSheetEmergencyCode0-9ButtonForm :>> issue coupon fail");
      }
    };

    // TODO(MTI): まるっとパスレポート不具合対応
    const executeValidAPI = async () => {
      try {
        // ブック自体を初めて使う場合はブックをvalidにする処理を挟む
        const validBookInAdvance = masterSheet.value.ignore_book_valid == false;
        if (validBookInAdvance && !book.value.is_valid) {
          await bookService.executeValidBooks(
            bookGroup.value,
            masterBook.value.is_multi_validatable
          );
          await issueExternalCoupon();
        }
        // MJのデータが複数モギリ可能と示唆しているか
        const isMultiValidable =
          book.value.master_limits[0].max_concurrent_punching > 1;
        console.log("isMultiValidable :>> ", isMultiValidable);

        // POSTの際のリクエストに設定するFrameIDを求める関数
        let apiFrame = await frameService.checkApiFrame(
          masterSheet.value,
          frame.value,
          isMultiValidable
        );

        if (apiFrame == "isMultiValidable") {
          console.log("フレーム複数有効化可能な場合");

          // 複数のフレームを有効化処理
          await API.validFramesWithCode(
            emergency_code.value,
            props.multiSheetValidIdsArray
          );
        } else if (apiFrame == "SubscriptionAndEmpty") {
          console.log("フレーム単数有効化 apiFrame", apiFrame);
          console.log("sheet.velue :>> ", sheet.value);
          // サブスクかつフレームが空であればPOST APIでフレームを新規作成する必要があり、そのレスポンスを代入
          apiFrame = await API.postFrames(sheet.value);

          console.log("executeValidAPI apiFrame :>> ", apiFrame);
          // 使用枚数を1で固定
          store.commit("ticketing/setStoreCountOfMultiSheets", 1);
          // 単数のフレームを有効化処理
          await API.validFrameWithCode(apiFrame.id, emergency_code.value);
        } else if (apiFrame == "normal") {
          // 複数枚購入sheetかどうかをcheck
          if (bookGroup.value.books.length > 1) {
            let frameArray = [];
            // frameのListを抽出
            for (let i = 0; i < bookGroup.value.books.length; i++) {
              for (let s = 0; s < bookGroup.value.books[i].sheets.length; s++) {
                if (
                  bookGroup.value.books[i].sheets[s].master_sheet_id ==
                  masterSheet.value.id
                ) {
                  let [return_used_frames, return_unused_frames] =
                    await frameService.setMultipleFrame(
                      bookGroup.value.books[i].sheets[s]
                    );
                  frameArray.push({ id: return_unused_frames[0].id });
                }
              }
            }
            console.log("MultiBooks SingularFrame", frameArray);
            // 複数有効化
            await API.validFramesWithCode(emergency_code.value, frameArray);
          } else {
            // 普通のシートであればすでにstoreに指定されたframeを代入
            apiFrame = frame.value;
            console.log("executeValidAPI apiFrame :>> ", apiFrame);
            // 使用枚数を1で固定
            store.commit("ticketing/setStoreCountOfMultiSheets", 1);
            // 単数のフレームを有効化処理
            await API.validFrameWithCode(apiFrame.id, emergency_code.value);
          }
        }

        if (!validBookInAdvance && !book.value.is_valid) {
          await bookService.executeValidBooks(
            bookGroup.value,
            masterBook.value.is_multi_validatable
          );
          await issueExternalCoupon();
        }

        nativeHandlerService.ncUseSheet(
          masterBook.value.id,
          bookGroup.value.id,
          book.value,
          masterBook.value.start_hour
        );

        return true;
      } catch (err) {
        resetCode();
        console.log("err :>> ", err);
        // 親コンポーネントでエラー内容に合わせて処理するので、イベント発火
        context.emit("error-handring", err.response.data.error);
        return false;
      }
    };

    // 7桁以上なのでワンタイムパスであると判断されてシートページへリダイレクト
    const redirectToSheetWithOnetimeCode = (code) => {
      router.push({
        name: "Sheet",
        params: {
          book_group_id: route.params.book_group_id,
          book_id: route.params.book_id,
          sheet_id: route.params.sheet_id,
          master_sheet_id: masterSheet.value.id,
        },
        query: {
          onetime: code,
        },
      });
    };

    // 救済コードが6文字に満たない場合はOKボタンを出さないので、Boolean管理
    watch(
      () => emergency_code.value,
      (newVal) => {
        isFulfill.value = newVal.length >= 6;
      }
    );

    return {
      emergency_code,
      pushedOK,
      isFulfill,
      joinNumberToCode,
      sliceNumberFromCode,
      issueExternalCoupon,
    };
  },
};
</script>

<style lang="scss" scoped>
.passcode__wrapper {
  width: 83vw;
  max-width: 272px;
  margin: auto;
  color: $white;
  top: var(--navigation-height);
  position: relative;

  .passcode__wrapper--title {
    text-align: center;
    padding-top: 42px;
    font-size: 14px;
  }
}
</style>
